import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-14 md:py-20 bg-off-white" data-id="element-215">
      <div className="container mx-auto px-4" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto space-y-8 text-lg md:text-xl text-navy leading-relaxed" data-id="element-217">
          <p className="font-serif text-2xl md:text-3xl font-medium italic text-center mb-12" data-id="element-218">
            "Déjame hacerte una pregunta honesta. <br data-id="element-219" />
            <span className="text-gold font-bold not-italic" data-id="element-220">
              ¿Sabes realmente qué cubre tu seguro?
            </span>
            "
          </p>

          <p data-id="element-221">
            No lo que crees que cubre. No lo que algún agente te explicó por
            teléfono hace tres años antes de ponerte en espera durante 45
            minutos. Sino lo que realmente cubre — hoy — cuando la vida golpea
            fuerte.
          </p>

          <p className="font-semibold" data-id="element-222">Porque la vida sí golpea fuerte.</p>

          <p data-id="element-223">
            Un accidente de carro. Un incendio. Una emergencia médica. Una
            tubería reventada. Una casa inundada.
          </p>

          <p data-id="element-224">
            Estos no son eventos raros. Le pasan a familias reales de Tampa.
            Cada. Semana.
          </p>

          <p data-id="element-225">
            Y cuando suceden — las personas que tenían la póliza equivocada, la
            cobertura incompleta, el deducible mal entendido — esas son las
            familias que quedan devastadas. No solo emocionalmente.
            Financieramente destruidas.
          </p>

          <div className="border-l-4 border-gold pl-6 py-2 my-10 bg-white shadow-sm p-6 rounded-r-lg" data-id="element-226">
            <p className="font-serif text-xl font-medium" data-id="element-227">
              Pero lo que nadie te dice es esto:
            </p>
            <p className="mt-4 font-bold" data-id="element-228">
              La póliza que compras hoy determina si tu familia estará protegida
              mañana — o luchando para sobrevivir cuando más te necesite.
            </p>
          </div>

          <p data-id="element-229">
            Por eso existe{' '}
            <strong className="text-gold" data-id="element-230">Angel Insurance</strong>. No para
            venderte una póliza y desaparecer. Sino para sentarse contigo — en
            persona, aquí mismo en Tampa — y asegurarse de que realmente
            entiendas lo que estás obteniendo. En inglés. En español. En tu
            idioma.
          </p>

          <p className="text-2xl font-serif font-bold text-center pt-8 border-t border-gray-200 mt-12" data-id="element-231">
            "Porque has trabajado demasiado duro para dejar el futuro de tu
            familia al azar."
          </p>
        </motion.div>
      </div>
    </section>;
}